import { Link } from "react-router-dom"

export default function ActionsCell({ session }) {
  return <Link to={`/courses/schedules/${session.schedule_id}/sessions/${session.id}/absent`} className="btn btn-sm btn-primary">View</Link>
}
